import tallyApi from 'app-lib/apis/tallyApi'
import { AnyProvider } from 'app-lib/providerUtils'
import { BigNumber } from '@0x/utils'

export interface IOnchainProposal {
  id: BigNumber
  proposer: string
  eta: BigNumber
  startBlock: BigNumber
  endBlock: BigNumber
  votes: {
    for: BigNumber
    against: BigNumber
    abstain: BigNumber
  }
  description: string
  canceled: boolean
  executed: boolean
  status: string
}

export default class DaoService {
  provider: AnyProvider

  /**
   * Get onchain proposals using Tally api
   */
  async getOnchainProposals(): Promise<IOnchainProposal[]> {
    const proposals = await tallyApi.getOokiProposals()
    return proposals.proposals.map((prop) => {
      return {
        id: new BigNumber(prop.id),
        description: prop.description,
        proposer: '',
        eta: new BigNumber(0),
        startBlock: new BigNumber(0),
        endBlock: new BigNumber(0),
        votes: {
          for: new BigNumber(
            prop.voteStats.find((vote) => vote.support === 'FOR')?.weight || 0
          ).div(10 ** 18),
          against: new BigNumber(
            prop.voteStats.find((vote) => vote.support === 'AGAINST')?.weight || 0
          ).div(10 ** 18),
          abstain: new BigNumber(
            prop.voteStats.find((vote) => vote.support === 'ABSTAIN')?.weight || 0
          ).div(10 ** 18),
        },
        canceled: false,
        status:
          prop.statusChanges.length > 0
            ? prop.statusChanges[prop.statusChanges.length - 1].type
            : 'Pending',
        executed: prop.statusChanges[prop.statusChanges.length - 1].type === 'EXECUTED',
      }
    })
  }

  constructor(provider: AnyProvider) {
    this.provider = provider
  }
}
